import { useEffect, useRef } from 'react';
import { useApiIsLoaded, useMapsLibrary } from '@vis.gl/react-google-maps';

export function useInitGooglePlaceAutocompleteService() {
  const isLoaded = useApiIsLoaded();
  const placesLib = useMapsLibrary('places');

  const autocompleteServiceRef =
    useRef<google.maps.places.AutocompleteService | null>(null);

  /**
   * initial Google Place Autocomplete Service
   */
  useEffect(() => {
    if (!isLoaded || !placesLib) return;

    if (!autocompleteServiceRef.current) {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService();
    }
  }, [isLoaded, placesLib]);

  return { autocompleteService: autocompleteServiceRef.current };
}
